// dependencies
import React from "react";
import { View, StyleSheet } from "react-native";

// components
import Text from "@cloudspire/legacy-resources/src/components/Text";

// libraries
import { emToPx } from "@cloudspire/legacy-resources/src/libraries";

type PropsType = {
  list: { label: string; value: string }[];
};

const styles = StyleSheet.create({
  item: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingTop: emToPx(0.5),
    borderStyle: "solid",
    borderColor: "#cfdadd",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
  },
  text: {
    fontSize: emToPx(0.875),
  },
});

const EstimateList: React.FunctionComponent<PropsType> = (props) => {
  const { list } = props;

  return (
    <>
      {list.map((item, index) => {
        return (
          <View
            key={index}
            style={[
              styles.item,
              {
                borderBottomWidth: index === list.length - 1 ? 0 : 1,
                paddingBottom: index === list.length - 1 ? 0 : emToPx(0.5),
              },
            ]}
          >
            <Text style={styles.text}>{item.label}</Text>

            <Text style={styles.text}>{item.value}</Text>
          </View>
        );
      })}
    </>
  );
};

export default EstimateList;
